import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");

const IntangibleAssetLedgerTable = ({ printMode = false }) => {
  const { list, loading, openingBalance, closingBalance } = useSelector(
    (state) => state.intangibleAssetLedger
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const columns = [
    {
      title: "No.",
      render: (_, record, index) => {
        if (record.vch_type === "Opening") return "-";
        // subtract 1 to account for the opening row at index 0
        return index;
      },
      width: 60,
    },
    {
      title: "Date",
      dataIndex: "created_date",
      render: (date) =>
        date ? moment(date).format("YYYY-MM-DD") : "-",
      width: 120,
    },
    {
      title: "Particular",
      dataIndex: "particular",
      width: 300,
      render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />,
    },
    {
      title: "VCH No",
      dataIndex: "vch_no",
      width: 120,
    },
    {
      title: "VCH Type",
      dataIndex: "vch_type",
      width: 120,
    },
    {
      title: "Debit",
      dataIndex: "debit_amount",
      render: (val, record) => {
        if (record.vch_type === "Opening") return "-";
        return format(parseFloat(val || 0).toFixed(2));
      },
      align: "right",
      width: 130,
    },
    {
      title: "Credit",
      dataIndex: "credit_amount",
      render: (val, record) => {
        if (record.vch_type === "Opening") return "-";
        return format(parseFloat(val || 0).toFixed(2));
      },
      align: "right",
      width: 130,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 130,
    },
  ];

  // Exclude opening row from grand total calculation
  const totals = list
    .filter((row) => row.vch_type !== "Opening")
    .reduce(
      (acc, row) => {
        acc.debit  += Number(row.debit_amount  || 0);
        acc.credit += Number(row.credit_amount || 0);
        return acc;
      },
      { debit: 0, credit: 0 }
    );

  return (
    <>
      <style>{`
        .opening-balance-row td {
          background-color: #f0f5ff !important;
          font-weight: 600;
        }
        .opening-balance-row:hover td {
          background-color: #e6edff !important;
        }
      `}</style>

      <Table
        rowKey={(_, index) => index}
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={
          printMode
            ? false
            : {
                ...pagination,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50"],
              }
        }
        onChange={(p) => setPagination(p)}
        bordered
        scroll={printMode ? undefined : { x: "max-content" }}
        size={printMode ? "small" : "middle"}
        rowClassName={(record) =>
          record.vch_type === "Opening" ? "opening-balance-row" : ""
        }
        summary={() => (
          <>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={5}>
                <strong>Grand Total</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">
                <strong>{format(totals.debit.toFixed(2))}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6} align="right">
                <strong>{format(totals.credit.toFixed(2))}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={7} align="right" />
            </Table.Summary.Row>

            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={5}>
                <strong>Closing Balance</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">
                <strong>{format(parseFloat(closingBalance || 0).toFixed(2))}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6} colSpan={2} />
            </Table.Summary.Row>
          </>
        )}
      />
    </>
  );
};

export default IntangibleAssetLedgerTable;